import { NgModule } from '@angular/core';
import { OnlyNumber } from "./onlynumber.directive";
import { SpecialCharacter } from "./onlychar.directive";
import { onlycharSpecialCharacter } from './onlycharSpecial.directive';
import { onlynumberSpecialCharacter } from './onlynumberSpecial.directive';
import { inputText } from './inputtext.directive';
import { PasswordOnly } from './password.directive';
import { TimeOnly } from './time.directive';
import { RoleDirective } from './role.directive';
import { panCharacter } from './pan.directive';
import { CopyTextDirective } from './copy-text.directive';
import { OnlyAlNumDirective } from './only-al-num.directive';
import { AlNumSlashDirective } from './al-num-slash.directive';
import { RemarksDirective } from './remarks.directive';
import { DecimalOnlyDirective } from './decimal-only.directive';

export const components = [
  OnlyNumber, SpecialCharacter, onlycharSpecialCharacter,
  onlynumberSpecialCharacter, inputText, PasswordOnly, TimeOnly,
  RoleDirective, panCharacter, CopyTextDirective, OnlyAlNumDirective,
  AlNumSlashDirective, RemarksDirective, DecimalOnlyDirective
];

@NgModule({
  declarations: [components],
  exports: [components]
})
export class DirectivesModule { }
